var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyFillArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 8,
    viewBox: "0 0 16 8",
    fill: "#757575",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.703 0.26385C15.5052 0.0879014 15.2708 0 14.9999 0H1.00008C0.729069 0 0.494784 0.0879014 0.296837 0.26385C0.0988911 0.439993 0 0.648242 0 0.888986C0 1.12968 0.0988911 1.33793 0.296837 1.51393L7.29676 7.73596C7.49493 7.9119 7.72921 8 8 8C8.27079 8 8.50529 7.9119 8.70307 7.73596L15.703 1.51388C15.9007 1.33793 16 1.12968 16 0.888937C16 0.648242 15.9007 0.439993 15.703 0.26385Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyFillArrow);
export default __webpack_public_path__ + "static/media/greyFillArrow.f995f9d853c39effc1ca977469bd8563.svg";
export { ForwardRef as ReactComponent };